export default "__VITE_ASSET__uVfe3OcX__"